<!--

    Copyright (c) 2017-present, Siklu Ltd.
    All rights reserved.

-->
<span
    [ngClass]="{
        'badge-success':
            userAuthority === userAuthorities.SIKLU_CUSTOMER_SUPPORT ||
            userAuthority === userAuthorities.SIKLU_SALES ||
            userAuthority === userAuthorities.SIKLU_ACCOUNTANT,
        'badge-danger': userAuthority === userAuthorities.COMPANY_ADMIN,
        'badge-warning': userAuthority === userAuthorities.COMPANY_PLANNER,
        'badge-primary': userAuthority === userAuthorities.COMPANY_USER
    }"
    class="badge badge-danger"
    >{{ 'gtthApp.authorities.' + userAuthority | translate }}</span
>
